import { FEATURE_FLAGS } from '../constants';

export const featureFlags = FEATURE_FLAGS;
export type FeatureFlags = typeof FEATURE_FLAGS;
